/**
 * Ar App
 * This is a simple API for AR App
 *
 * OpenAPI spec version: 1.0.0
 * Contact: csong@lsq.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ArError } from '../model/arError';
import { ProspectData } from '../model/prospectData';
import { ProspectInvitation } from '../model/prospectInvitation';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class OperationService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Migrate a prospect application. Admin only.
     * Migrate a prospect to AR Dashboard. Admin only.
     * @param prospectId pass an optional id for the prospect company
     * @param clientNumber pass the factorsoft client number to associate the prospect with
     * @param migratedBy email address of admin user who migrated the prospect
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public migrateProspectAndUser(prospectId: string, clientNumber: string, migratedBy: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public migrateProspectAndUser(prospectId: string, clientNumber: string, migratedBy: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public migrateProspectAndUser(prospectId: string, clientNumber: string, migratedBy: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public migrateProspectAndUser(prospectId: string, clientNumber: string, migratedBy: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling migrateProspectAndUser.');
        }

        if (clientNumber === null || clientNumber === undefined) {
            throw new Error('Required parameter clientNumber was null or undefined when calling migrateProspectAndUser.');
        }

        if (migratedBy === null || migratedBy === undefined) {
            throw new Error('Required parameter migratedBy was null or undefined when calling migrateProspectAndUser.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (clientNumber !== undefined && clientNumber !== null) {
            queryParameters = queryParameters.set('client_number', <any>clientNumber);
        }
        if (migratedBy !== undefined && migratedBy !== null) {
            queryParameters = queryParameters.set('migrated_by', <any>migratedBy);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/prospectData/migrate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Send a prospect&#x27;s invitation. Admin only
     * By passing in the appropriate options, you can send a prospect invitation. Admin only
     * @param body Prospect JSON object to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postProspectDataInvitation(body: ProspectInvitation, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public postProspectDataInvitation(body: ProspectInvitation, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public postProspectDataInvitation(body: ProspectInvitation, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public postProspectDataInvitation(body: ProspectInvitation, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling postProspectDataInvitation.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            '*/*'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/prospectData/invitation`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Register a prospect user and company with Exchange
     * Create a user and company for prospect in Exchange
     * @param firstName pass the first name of the user
     * @param lastName pass the last name of the user
     * @param businessName pass the name of the company
     * @param phone pass the user&#x27;s phone number
     * @param email pass the user&#x27;s email address
     * @param password pass the user&#x27;s password
     * @param token pass a token for verify the prospect
     * @param prospectId pass an optional id for the prospect company
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public registerUserAndProspect(firstName: string, lastName: string, businessName: string, phone: string, email: string, password: string, token: string, prospectId?: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public registerUserAndProspect(firstName: string, lastName: string, businessName: string, phone: string, email: string, password: string, token: string, prospectId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public registerUserAndProspect(firstName: string, lastName: string, businessName: string, phone: string, email: string, password: string, token: string, prospectId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public registerUserAndProspect(firstName: string, lastName: string, businessName: string, phone: string, email: string, password: string, token: string, prospectId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (firstName === null || firstName === undefined) {
            throw new Error('Required parameter firstName was null or undefined when calling registerUserAndProspect.');
        }

        if (lastName === null || lastName === undefined) {
            throw new Error('Required parameter lastName was null or undefined when calling registerUserAndProspect.');
        }

        if (businessName === null || businessName === undefined) {
            throw new Error('Required parameter businessName was null or undefined when calling registerUserAndProspect.');
        }

        if (phone === null || phone === undefined) {
            throw new Error('Required parameter phone was null or undefined when calling registerUserAndProspect.');
        }

        if (email === null || email === undefined) {
            throw new Error('Required parameter email was null or undefined when calling registerUserAndProspect.');
        }

        if (password === null || password === undefined) {
            throw new Error('Required parameter password was null or undefined when calling registerUserAndProspect.');
        }

        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling registerUserAndProspect.');
        }


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }
        if (firstName !== undefined && firstName !== null) {
            queryParameters = queryParameters.set('first_name', <any>firstName);
        }
        if (lastName !== undefined && lastName !== null) {
            queryParameters = queryParameters.set('last_name', <any>lastName);
        }
        if (businessName !== undefined && businessName !== null) {
            queryParameters = queryParameters.set('business_name', <any>businessName);
        }
        if (phone !== undefined && phone !== null) {
            queryParameters = queryParameters.set('phone', <any>phone);
        }
        if (email !== undefined && email !== null) {
            queryParameters = queryParameters.set('email', <any>email);
        }
        if (password !== undefined && password !== null) {
            queryParameters = queryParameters.set('password', <any>password);
        }
        if (token !== undefined && token !== null) {
            queryParameters = queryParameters.set('token', <any>token);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/prospectData/registerUser`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Relocates a field object into a new stage.
     * Moves the FieldData and its corresponding FieldSchema object from one stage to another.
     * @param prospectId Id of the prospectData that contains the field to be relocated.
     * @param fieldId Id of the field to be relocated.
     * @param originStageId Id of the stage from where the field will be relocated.
     * @param targetStageId Id of the stage where the field will be relocated to.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public relocateField(prospectId: string, fieldId: string, originStageId: string, targetStageId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public relocateField(prospectId: string, fieldId: string, originStageId: string, targetStageId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public relocateField(prospectId: string, fieldId: string, originStageId: string, targetStageId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public relocateField(prospectId: string, fieldId: string, originStageId: string, targetStageId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling relocateField.');
        }

        if (fieldId === null || fieldId === undefined) {
            throw new Error('Required parameter fieldId was null or undefined when calling relocateField.');
        }

        if (originStageId === null || originStageId === undefined) {
            throw new Error('Required parameter originStageId was null or undefined when calling relocateField.');
        }

        if (targetStageId === null || targetStageId === undefined) {
            throw new Error('Required parameter targetStageId was null or undefined when calling relocateField.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospectId', <any>prospectId);
        }
        if (fieldId !== undefined && fieldId !== null) {
            queryParameters = queryParameters.set('fieldId', <any>fieldId);
        }
        if (originStageId !== undefined && originStageId !== null) {
            queryParameters = queryParameters.set('originStageId', <any>originStageId);
        }
        if (targetStageId !== undefined && targetStageId !== null) {
            queryParameters = queryParameters.set('targetStageId', <any>targetStageId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/v1/prospectData/relocateField`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Submit a prospect application
     * Submit a prospect application
     * @param prospectId pass an optional id for the prospect company
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public submitProspectData(prospectId: string, observe?: 'body', reportProgress?: boolean): Observable<ProspectData>;
    public submitProspectData(prospectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProspectData>>;
    public submitProspectData(prospectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProspectData>>;
    public submitProspectData(prospectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (prospectId === null || prospectId === undefined) {
            throw new Error('Required parameter prospectId was null or undefined when calling submitProspectData.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (prospectId !== undefined && prospectId !== null) {
            queryParameters = queryParameters.set('prospect_id', <any>prospectId);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // authentication (auth_jwt) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ProspectData>('post',`${this.basePath}/v1/prospectData/submit`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
